import React from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/HomePageStyles/heroSectionsStyle.css";

import roll1 from "../assets/Herosection/header1.png";
import roll2 from "../assets/Herosection/roll2.webp";
import roll3 from "../assets/Herosection/roll3.webp";
import roll4 from "../assets/Herosection/roll4.webp";
import roll5 from "../assets/Herosection/roll5.webp";
import roll6 from "../assets/Herosection/roll6.webp";
import roll7 from "../assets/Herosection/header2.png";
import OrderBtn from "../utils/OrderBtn";
import config from "../config";

const HeroSection = ({
  slide1_title,
  slide1_description,
  slide1_middle_image,
  slide1_left_image,
  slide1_right_image,
  slide2_title,
  slide2_description,
  slide2_middle_image,
  slide2_left_image,
  slide2_right_image,
  slide3_title,
  slide3_description,
  slide3_middle_image,
  slide3_left_image,
  slide3_right_image,
}) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    customPaging: function (i) {
      return (
        <div className="custom-dot">
          <span>
            <i className="bi bi-dot"></i>
          </span>
        </div>
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="hero_container">
        <Slider {...settings}>
          <div>
            <div className="carousel-slide hero-sec-bg hero_section slider1">
              {/*  ${slidIndex === 1 && 'customFadeUp'} */}
              <div className={`slider-content hero_content1`}>
                <div className="hero-caption-wrapper">
                  <div className="her_left_img">
                    <img
                      src={slide1_left_image ? slide1_left_image : roll7}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>

                  <div className="hero_content">
                    <div className="hero_caption">
                      {slide1_title && slide1_title.trim() !== "-" ? (
                        <h1 className="hero_heading">
                          {slide1_title}
                          {/* {slide1_middle_image} */}
                          {/* <span>
                            <img src={slide1_middle_image} alt="" className="img-fluid"></img>

                          </span> */}
                        </h1>
                      ) : (
                        <h1 className="hero_heading">
                          Welcome to a World
                          <span>
                            of{" "}
                            <img
                              src={roll2}
                              className="img-fluid"
                              alt="Ice Cream"
                            />
                          </span>
                          Sweet Delight!
                        </h1>
                      )}

                      {/* <p className=""> */}
                      {/* Explore our mouthwatering ice cream flavors, crafted to
                        make every moment a little sweeter. From classic
                        favorites to innovative new creations, we’ve got
                        something to satisfy every craving. */}
                      {slide1_description &&
                      slide1_description.trim() !== "-" ? (
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: slide1_description,
                            }}
                          ></div>
                        </p>
                      ) : (
                        <p>
                          Explore our mouthwatering ice cream flavors, crafted
                          to make every moment a little sweeter. From classic
                          favorites to innovative new creations, we’ve got
                          something to satisfy every craving.
                        </p>
                      )}
                      {/* </p> */}
                    </div>

                    {/* <div className="order-online">
                      <div className="order-online-trans-1"></div>
                      <div className="order-online-trans-2"></div>
                      <a
                        className="hero-anchor blue-btn"
                        href=""
                        target="_self"
                      >
                        Find Your Location
                      </a>
                    </div> */}
                    <OrderBtn text={"Find Your Location"} url={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}`} />
                  </div>

                  <div className="her_right_img">
                    <img
                      src={slide1_right_image ? slide1_right_image : roll1}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="carousel-slide hero-sec-bg hero_section slider2">
              {/*  ${slidIndex === 2 && 'customFadeUp'} */}
              <div className={`slider-content hero_content1`}>
                <div className="hero-caption-wrapper">
                  <div className="her_left_img">
                    <img
                      src={slide2_left_image ? slide2_left_image : roll3}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>

                  <div className="hero_content">
                    <div className="hero_caption">
                      {slide2_title && slide2_title.trim() !== "-" ? (
                        <h1 className="hero_heading">
                          <span>{slide2_title}</span>
                        </h1>
                      ) : (
                        <h1 className="hero_heading">
                          <span>
                            {" "}
                            Flavors{" "}
                            <img
                              src={roll2}
                              className="img-fluid"
                              alt="Ice Cream"
                            />
                          </span>
                          That Dance on Your Taste Buds!
                        </h1>
                      )}
                      {slide2_description &&
                      slide2_description.trim() !== "-" ? (
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: slide2_description,
                            }}
                          ></div>
                        </p>
                      ) : (
                        <p className="">
                          From creamy classics to daring combinations, each
                          scoop is a journey of flavor. Ready to discover your
                          next favorite indulgence? Start exploring below!
                        </p>
                      )}
                    </div>

                    <OrderBtn text={"Find Your Location"} url={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-") || ""}`} />
                  </div>

                  <div className="her_right_img">
                    <img
                      src={slide2_right_image ? slide2_right_image : roll4}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="carousel-slide hero-sec-bg hero_section slider3">
              {/*  ${slidIndex === 3 && 'customFadeUp'} */}
              <div className={`slider-content hero_content1`}>
                <div className="hero-caption-wrapper">
                  <div className="her_left_img">
                    <img
                      src={slide3_left_image ? slide3_left_image : roll5}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>

                  <div className="hero_content">
                    <div className="hero_caption">
                      {slide3_title && slide3_title.trim() !== "-" ? (
                        <h1 className="hero_heading">{slide3_title}</h1>
                      ) : (
                        <h1 className="hero_heading">
                          <span>
                            Craving{" "}
                            <img
                              src={roll2}
                              className="img-fluid"
                              alt="Ice Cream"
                            />
                            Ice Cream?
                          </span>{" "}
                          We’ve Got You Covered!
                        </h1>
                      )}

                      {slide3_description &&
                      slide3_description.trim() !== "-" ? (
                        <p className="">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: slide3_description,
                            }}
                          ></div>
                        </p>
                      ) : (
                        <p className="">
                          Satisfy your sweet tooth with a few clicks. Order your
                          favorite flavors, sundaes, or shakes, and let us bring
                          the joy to you—no matter where you are.
                        </p>
                      )}
                    </div>

                    <OrderBtn text={"Find Your Location"} url={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-") || ""}`} />
                  </div>

                  <div className="her_right_img">
                    <img
                      src={slide3_right_image ? slide3_right_image : roll6}
                      alt="ice cream 1"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>

        <div className="hero-bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            // fill="#ffecf0"
            fill="var(--heading-color)"
          >
            <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
